import type { Grade, Subject } from '@viastud/utils'
import { create } from 'zustand'

export interface ParentOnboardingChildBase {
  id: string
  type: 'NEW_CHILD' | 'IMPORTED_CHILD'
}

export type ParentChildGrade = Extract<Grade, 'TROISIEME' | 'SECONDE' | 'PREMIERE' | 'TERMINALE'>

export type ParentOnboardingNewChild = ParentOnboardingChildBase & {
  type: 'NEW_CHILD'
  firstName: string
  lastName: string
  email: string
  phoneNumber: string
  grade: ParentChildGrade
  phoneVerified: boolean
}

export type ParentOnboardingImportedChild = ParentOnboardingChildBase & {
  type: 'IMPORTED_CHILD'
  email: string
}

export type ParentOnboardingChild = ParentOnboardingNewChild | ParentOnboardingImportedChild

export interface OnboardingState {
  page: number
  grade?: Grade
  role?: 'STUDENT' | 'PARENT'
  interestedIn: Subject[]
  doneModules: number[]
  doingModules: number[]
  parentChildren: ParentOnboardingChild[]
  updateOnBoardingState: (state: Partial<OnboardingState>) => void
}

export const useOnBoardingStore = create<OnboardingState>()((set) => ({
  page: 1,
  role: 'STUDENT',
  grade: 'TROISIEME',
  interestedIn: [],
  doneModules: [],
  doingModules: [],
  parentChildren: [],
  updateOnBoardingState: (state) => {
    set((prev) => ({ ...prev, ...state }))
  },
}))
